import { inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import {
    HttpTransportType,
    HubConnection,
    HubConnectionBuilder,
    IHttpConnectionOptions,
    LogLevel,
} from '@microsoft/signalr';
import { APP_CONFIG } from '../../../env/env.token';
import { SessionData } from '../../../app/auth/models/session-data.model';
import { LocalStorageService } from '../../services/browser-storage/local-storage.service';
import { LocalStorageKeys } from '../../services/browser-storage/types/local-storage.enum';
import { BidHistoryCreatedMessage } from './types';

@Injectable({ providedIn: 'root' })
export class BidHistoryReportingHubService {
    private readonly appConfig = inject(APP_CONFIG);
    private readonly localStorage = inject(LocalStorageService);

    private readonly hubUrl = `${this.appConfig.notificationsUrl}/bidHistoryReportingHub`;

    private connection: HubConnection;

    private readonly _bidHistoryCreated$ = new Subject<BidHistoryCreatedMessage>();

    readonly bidHistoryCreated$ = this._bidHistoryCreated$.asObservable();

    constructor() {
        this.init();
    }

    private init(): void {
        const options: IHttpConnectionOptions = {
            transport: HttpTransportType.WebSockets,
            skipNegotiation: true,
            accessTokenFactory: () => this.localStorage.getItem<SessionData>(LocalStorageKeys.SessionData)?.accessToken,
        };

        const logLevel = this.appConfig.environment === 'Production' ? LogLevel.Error : LogLevel.Information;

        this.connection = new HubConnectionBuilder()
            .withUrl(this.hubUrl, options)
            .withAutomaticReconnect()
            .configureLogging(logLevel)
            .build();

        this.connection.on('ReportBidHistoryCreated', (msg: BidHistoryCreatedMessage) => {
            this._bidHistoryCreated$.next(msg);
        });

        this.connection.start().catch((err) => console.error('[BidHistoryReportingHub] connection error', err));
    }
}
